import { GenericParamFields, ParamFormRow } from "entity/Indicador/components/ParamFields";
import PerdM from "..";
import TextInput from "components/form/input/TextInput";
import CheckboxInput from "components/form/input/CheckboxInput";

export function PerdMParamFields({ tipoIndicadorField }) {
    return (
        <GenericParamFields
            name={PerdM.field + tipoIndicadorField}
            bottomFields={
                <>
                    <ParamFormRow label="Meta">
                        <TextInput name="manual.meta" label="Meta (%)" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Tamanho do Ponto">
                        <TextInput name="manual.tamanhoPonto" label="Tamanho do Ponto" type="number" />
                    </ParamFormRow>
                    <ParamFormRow label="Opções coleta">
                        <CheckboxInput name="manual.toco" label="Toco" />
                        <CheckboxInput name="manual.ponteiro" label="Ponteiro" />
                        <CheckboxInput name="manual.canaInteira" label="Cana Inteira" />
                        <CheckboxInput name="manual.canaFixa" label="Cana Fixa" />
                        <CheckboxInput name="manual.estilhaco" label="Estilhaço" />
                        <CheckboxInput name="manual.tolete" label="Tolete" />
                        <CheckboxInput name="manual.pedaco" label="Pedaço" />
                        <CheckboxInput name="manual.lasca" label="Lasca" />
                        <CheckboxInput name="manual.toleteEstilhacado" label="Tolete Estilhaçado" />
                    </ParamFormRow>
                </>
            }
        />
    );
}
